import { prepareWriteContract } from "@wagmi/core"
import { BigNumber } from "ethers"
import { writeContract } from "@wagmi/core"
import { erc20ABI } from "wagmi"
import { NewTransaction } from "../PayProducts/PayProducts"
import { constants } from "@src/constants"

const SetERC20Approve = async (
  address: string,
  amount: BigNumber,
  addRecentTransaction: (transaction: NewTransaction) => void | undefined,
  chainId: number
) => {
  try {
    const { request } = await prepareWriteContract({
      address,
      abi: erc20ABI,
      functionName: "approve",
      args: [
        constants[chainId].addresses["ProductsModule"],
        BigInt(amount.toHexString())
      ]
    })
    const { hash } = await writeContract(request)
    addRecentTransaction?.({
      hash,
      description: "Approve USDC"
    })
    return hash
  } catch (err) {
    throw err
  }
}

export default SetERC20Approve
